import React from "react";
import { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const SliderLeftArrow = ({ color = "black" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M18.667 9.3335L12.0003 16.0002L18.667 22.6668"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SliderLeftArrow;
